import { useTranslations } from "next-intl";
import { ReportCard as ReportCardComponent } from "@carfax/web-ui/components/ReportCard";
import { Routes } from "utils/config/routes";
import { VhrStatus } from "domain/User/Common/utils/dashboard-api";
import { linkUtil } from "utils/i18n/link-util";
import { ReportCardDetailsProps } from "@carfax/web-ui/components/ReportCard/ReportCard";
import { detailsResolver } from "domain/User/Account/Reports/reportDetailsResolver";
import { vhrUrlUtil } from "utils/vhr/vhr-url-util";
import { styles } from "./ReportCard.style";

interface Props {
  uuid: string;
  makeAndModel: string;
  vinreg: string;
  purchaseDate: Date;
  expiryDate: Date;
  expired: boolean;
  status: VhrStatus;
  riskFactorNumber: number;
  encryptedVinreg: string;
}

const ReportCard: React.FC<Props> = ({
  uuid,
  makeAndModel,
  purchaseDate,
  expiryDate,
  vinreg,
  riskFactorNumber,
  expired,
  status,
  encryptedVinreg,
}) => {
  const t = useTranslations("page-account-dashboard");
  const reactivateReportPaymentUrl = encryptedVinreg
    ? Routes.reactivateReportPayment(encryptedVinreg, true)
    : Routes.reactivateReportPayment(vinreg, false);
  const makeAndModelTitle = t("reportSection.makeAndModelTitle");
  const vinregTitle = t("reportSection.vinregTitle");
  const purchasedTitle = t("reportSection.purchasedTitle");
  const statusTitle = t("reportSection.statusTitle");
  const href = expired
    ? reactivateReportPaymentUrl
    : vhrUrlUtil.buildVhrUrl({
        reportId: uuid,
      });
  const buttonText = expired ? t("reportSection.reactivateReport") : t("reportSection.viewReport");
  const tReports = useTranslations("page-account-reports");
  const details: ReportCardDetailsProps = detailsResolver.calculateDetailsBasedOnExpiryAndStatus(
    purchaseDate,
    expiryDate,
    status,
    expired,
    tReports,
  );
  const hasRisk = riskFactorNumber > 0;
  const riskText = t("reportSection.riskFound");

  return expired ? (
    <a href={linkUtil.i18nLink(href)} data-testid="report-card" className={styles.reportLink()}>
      <ReportCardComponent
        makeAndModelTitle={makeAndModelTitle}
        vinregTitle={vinregTitle}
        purchasedTitle={purchasedTitle}
        statusTitle={statusTitle}
        licensePlateOrVin={vinreg}
        makeAndModel={makeAndModel}
        buttonText={buttonText}
        details={details}
        hasRisk={hasRisk}
        riskText={riskText}
        displayShortCard
      />
    </a>
  ) : (
    <a
      href={linkUtil.i18nLink(href)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="report-card"
      className={styles.reportLink()}
    >
      <ReportCardComponent
        makeAndModelTitle={makeAndModelTitle}
        vinregTitle={vinregTitle}
        purchasedTitle={purchasedTitle}
        statusTitle={statusTitle}
        licensePlateOrVin={vinreg}
        makeAndModel={makeAndModel}
        buttonText={buttonText}
        details={details}
        hasRisk={hasRisk}
        riskText={riskText}
        displayShortCard
      />
    </a>
  );
};

export default ReportCard;
